<template>
  <section class="section pt-5">
    <team-datatable />
  </section>
</template>

<script>
import TeamDatatable from "./team_datatable/Index.vue";

export default {
  name: "PatientTeam",
  components: { TeamDatatable },
  data() {
    return {
      is_loading: false,
    };
  },
  methods: {
    retrieve_settings() {
      // get_configuration(this)
      //   .then((conf) => {
      //     console.log("configuration retrieved", conf);
      //   })
      //   .catch((error) => {
      //     console.error(error);
      //   });
    },
    create() {
      console.log("create order");
    },
    refresh() {
      console.log("refresh orders");
    },
  },
  mounted() {},
  created() {},
};
</script>

<style scoped></style>
